import { Editor } from "@tinymce/tinymce-react";
import { Skeleton } from "antd";
import React, { ComponentProps, Suspense } from "react";

type VpdInlineProps = ComponentProps<typeof Editor> & { defaultFont?: string };

export const VpdInlineEditor = ({ defaultFont, ...editorProps }: VpdInlineProps) => {
  const defaultInit: ComponentProps<typeof Editor>["init"] = {
    // @ts-ignore
    license_key: "gpl",
    setup(editor) {
      if (defaultFont) {
        const fontName = defaultFont.split("=")[1];
        editor.on("init", () => {
          try {
            editor.execCommand("FontName", false, fontName);
          } catch (e) {
            console.log("error", e);
          }
        });
        editor.on("NodeChange", function (e) {
          const node = e.target.selection.getNode();
          const currentFont = editor.dom.getStyle(node, "font-family");
          if (currentFont !== fontName) {
            editor.dom.setStyle(node, "font-family", fontName);
          }
        });
      }
    },
    toolbar: "undo redo | bold italic underline",
    menubar: false,
    fontsize_formats: "8px 10px 12px 14px 16px 18px 24px 36px",
    font_family_formats: defaultFont?.split("=")[1],
    default_font_stack: [defaultFont?.split("=")[0] ?? "Arial"],
    font_size_default: "12px",
    newline_behavior: "linebreak",
    forced_root_block: "div",
    verify_html: false,
    indent: false,
    promotion: false,
    content_style: `
      .mce-content-body { 
        border: 1px solid #d9d9d9 !important;
        padding: 4px 8px !important;
        min-height: 32px !important;
        box-shadow: none !important;
      }
      .mce-content-body:focus,
      .mce-content-body:hover,
      body.mce-content-body:not([contenteditable=false]):focus,
      body.mce-content-body:not([contenteditable=false]):hover {
        border: 1px solid #d9d9d9 !important;
        outline: none !important;
        box-shadow: none !important;
      }

    `,
  };

  return (
    <Suspense fallback={<Skeleton active />}>
      <Editor
        tinymceScriptSrc={`https://assets.vpd.law/vpd-ui/tinymce/js/tinymce/tinymce.min.js`}
        {...editorProps}
        inline={true}
        init={defaultInit}
      />
    </Suspense>
  );
};
